import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import RolesActionButtions from './ActionButtons/RolesActionButtons';
import Table from './Table';
import Loader from '../../shared/Loaders/Loader';
import RolePageContainer from './RolePageContainer';
import { ADMIN_ROLES_PAGE_VIEW } from '../../../constants/analytics';
import { trackAdminEvent } from '../../../utils/trackAdminEvent';

const styles = (theme) => ({
  container: {
    minHeight: 'calc(100vh - 80px)',
    boxSizing: 'border-box',
    padding: '40px 0px',
    maxWidth: '990px',
    width: '100%',
    margin: '0px auto',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: theme.spacing(4),
    backgroundColor: '#fafafa',
  },
});

class Roles extends Component<any> {
  state = {
    loading: true,
  };

  private hasTrackedPageView = false;

  componentDidMount = async () => {
    try {
      await this.props.fetchRoles();
      if (!this.hasTrackedPageView) {
        trackAdminEvent(ADMIN_ROLES_PAGE_VIEW);
        this.hasTrackedPageView = true;
      }
    } catch (error) {
      // Error is already handled in the action, just ensure loading is set to false
      console.error('Error fetching roles:', error);
    } finally {
      this.setState({ loading: false });
    }
  };
  render() {
    if (this.state.loading) {
      return <Loader />;
    }
    return (
      <RolePageContainer title={'Manage Roles'}>
        <RolesActionButtions />
        <Table
          roles={this.props.roles}
          totalPermissions={this.props.totalPermissions}
        />
      </RolePageContainer>
    );
  }
}

export default withStyles(styles as any, { withTheme: true })(Roles);
